import React from 'react';
import '../style/Components.css';

const Header = () => {
	return (
		<div>
			<div className="header">
				<p>The</p>
				<h1>Siren</h1>
			</div>
		</div>
	);
};

export default Header;
